import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const TRANSFERTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.TransferType.Name')
    .required()
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('value', 'Entity.TransferType.Value')
    .required()
    .maxLength(50)
    .build(),
];

export const TRANSFERTYPE_CONFIG = {
  entityName: 'TransferType',
  localizationKey: 'Controlling::Entity.TransferType',
  fields: TRANSFERTYPE_FIELDS,
  permission: 'ControllingLiquidations.TransferTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
